(function () {
    document.addEventListener('DOMContentLoaded', () => {
        const infoOverlay = document.querySelector('.info-overlay');
        const modals      = document.querySelectorAll('.info-modal');
        const buttons     = document.querySelectorAll('[data-target]');
        const closeButtons = document.querySelectorAll('.modal-close');
        const body        = document.body;

        // scrollbar layout fix
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
        document.documentElement.style.setProperty(
            '--scrollbar-width',
            `${scrollbarWidth}px`
        );

        // open modal
        buttons.forEach(button => {
            button.addEventListener('click', () => {
                const target = button.dataset.target;

                modals.forEach(modal => modal.classList.remove('active'));

                const activeModal = infoOverlay.querySelector(
                    `[data-modal="${target}"]`
                );

                if (activeModal) {
                    activeModal.classList.add('active');
                }

                infoOverlay.classList.add('active');
                body.classList.add('modal-open');
            });
        });

        // close via overlay click
        infoOverlay.addEventListener('click', (e) => {
            if (e.target === e.currentTarget) {
                closeModal();
            }
        });

        // close via × button
        closeButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                e.stopPropagation();
                closeModal();
            });
        });

        function closeModal() {
            infoOverlay.classList.remove('active');
            body.classList.remove('modal-open');
            modals.forEach(modal => modal.classList.remove('active'));
        }
    });
})();